/**
 * @prettier
 */

// React Packages
import React, { Component } from "react";
import { connect } from "react-redux";

// Actions
import { finalizeThenSuccess } from "../../state/actions/navigatorActions";

// Components
import Error from "./Error";
import { LoadingStateAnimation } from "../../components/ProcessingLayout";

class DefaultError extends Component {
    constructor(props) {
        super(props);
        this.state = {
            processing: false,
            retryAction: null,
        };
    }

    componentDidMount() {
        // Determine where the error occurred if outside of component
        if (
            this.props.location.state &&
            this.props.location.state.type === "finalize"
        ) {
            this.setState({
                retryAction: () => {
                    this.setState({ processing: true });
                    finalizeThenSuccess();
                },
            });
        }
    }

    render() {
        return (
            <>
                {this.state.processing === true && (
                    <div className="u-display-loading u-text-center">
                        <LoadingStateAnimation
                            brandingColor={this.brandingColor}
                        />
                    </div>
                )}

                {this.state.processing === false && (
                    <Error retryAction={this.state.retryAction} />
                )}
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        branding: state.config.profile,
    };
}

export default connect(mapStateToProps)(DefaultError);
